import Layout from '@/layout'

const merchantRouter = {
  path: "/merchants",
  redirect: '/merchants/list',
  name: 'merchantsL',
  hiddeChilden: false,
  hidden: false,
  meta: { title: 'menu.merchantsGroupName', iconClass: 'el-icon-files', module: 'merchants', roles: ['MERCHANT_USER', 'MERCHANT_MANAGER', 'MERCHANT_OBSERVER', "PUBLIC_MERCHANT_USER", "BUSINESS_CHANCE_USER", "BUSINESS_CHANCE_ADMIN", "BUSINESS_CHANCE_OBSERVER"] },
  component: Layout,
  children: [
    // 漏斗图
    {
      path: "/merchants/dashboard",
      name: "merchantsDashboard",
      hidden: false,
      component: () => import("@/views/merchants/merchantsDashboard"),
      meta: { title: 'menu.merchantsDashboard', iconClass: 'el-icon-files', module: 'merchants', keepAlive: true, roles: ["MERCHANT_USER", "MERCHANT_MINISTER", "MERCHANT_MANAGER", "MERCHANT_OBSERVER"]}
    },
    // 公共池
    {
      path: "/merchants/public/list",
      name: "publicMerchantList",
      hidden: false,
      component: () => import("@/views/public_merchants/publicMerchantsList"),
      meta: { title: 'menu.publicMerchants', iconClass: 'el-icon-files', module: 'merchants', keepAlive: true, roles: ['MERCHANT_MANAGER', 'MERCHANT_OBSERVER', 'PUBLIC_MERCHANT_USER']}
    },
    {
      path: "/merchants/public/detail",
      name: "publicMerchantDetail",
      hidden: true,
      component: () => import("@/views/public_merchants/publicMerchantsDetail"),
      meta: { title: 'menu.publicMerchants', iconClass: 'el-icon-files', module: 'merchants', keepAlive: false, roles: ['MERCHANT_MANAGER', 'MERCHANT_OBSERVER', 'PUBLIC_MERCHANT_USER']}
    },
    // 线索部分
    {
      path: "/merchants/list",
      name: "merchantList",
      hidden: false,
      component: () => import("@/views/merchants/merchantsList"),
      meta: { title: 'menu.merchants', iconClass: 'el-icon-files', module: 'merchants', keepAlive: true, roles: ['MERCHANT_USER', 'MERCHANT_MINISTER', 'MERCHANT_MANAGER', 'MERCHANT_OBSERVER']}
    },
    {
      path: "/merchants/self/list",
      name: "merchantSelftList",
      hidden: false,
      component: () => import("@/views/merchants/merchantsSelfList"),
      meta: { title: 'menu.merchantSelf', iconClass: 'el-icon-files', module: 'merchants', keepAlive: true, roles: ['MERCHANT_USER', 'MERCHANT_MINISTER', 'MERCHANT_MANAGER', 'MERCHANT_OBSERVER']}
    },
    {
      path: "/merchants/detail",
      name: "merchantDetail",
      hidden: true,
      component: () => import("@/views/merchants/merchantsDetail"),
      meta: { title: 'menu.merchantsDetail', iconClass: 'el-icon-files', module: 'merchants', keepAlive: false, roles: ['MERCHANT_USER', 'MERCHANT_MINISTER', 'MERCHANT_MANAGER', 'MERCHANT_OBSERVER'] }
    },
    // 线索[招商]途径
    {
      path: "/merchants/sources/list",
      name: "merchantSourcesList",
      hidden:true,
      component: () => import( "@/views/merchants/merchantSources"),
      meta: { title: 'menu.merchantSources', iconClass: 'el-icon-files', module:'merchantsSources', keepAlive: true, roles:['MERCHANT_MANAGER']}
    },
    // 线索[招商]阶段
    {
      path: "/merchants/stages/list",
      name: "merchantStagesList",
      hidden:true,
      component: () => import( "@/views/merchants/merchantStates"),
      meta: { title: 'menu.merchantStages', iconClass: 'el-icon-files', module:'merchantStages', keepAlive: true, roles:['MERCHANT_MANAGER']}
    },
    // 线索来源部分
    {
      path: "/company/list",
      name: "company",
      hidden:false,
      component: () => import( "@/views/company/companyList"),
      meta: { title: 'menu.company', iconClass: 'el-icon-files', module:'company', keepAlive: true, roles:['MERCHANT_MANAGER']}
    },
    // 商机部分
    {
      path: "/business/chances/list",
      name: "businessChancesList",
      hidden: false,
      component: () => import("@/views/business_chances/businessChancesList"),
      meta: { title: 'menu.businessChances', iconClass: 'el-icon-files', module: 'businessChances', keepAlive: true, roles: ["BUSINESS_CHANCE_USER", "BUSINESS_CHANCE_ADMIN", "BUSINESS_CHANCE_OBSERVER"] }
    },
    {
      path: "/business/chances/detail",
      name: "businessChancesDetail",
      hidden: true,
      component: () => import("@/views/business_chances/businessChancesDetail"),
      meta: { title: 'menu.businessChancesDetail', iconClass: 'el-icon-files', module: 'businessChances', keepAlive: false, roles: ["BUSINESS_CHANCE_USER", "BUSINESS_CHANCE_ADMIN", "BUSINESS_CHANCE_OBSERVER"] }
    },
    {
      path: "/business/chances/source",
      name: "businessChancesSourceList",
      hidden: true,
      component: () => import("@/views/business_chances/businessChancesSourceList"),
      meta: { title: 'menu.businessChances', iconClass: 'el-icon-files', module: 'businessChances', keepAlive: false, roles: ["BUSINESS_CHANCE_USER", "BUSINESS_CHANCE_ADMIN", "BUSINESS_CHANCE_OBSERVER"] }
    },
    {
      path: "/business/chances/stages",
      name: "businessChancesStagesList",
      hidden: true,
      component: () => import("@/views/business_chances/businessChancesStagesList"),
      meta: { title: 'menu.businessChances', iconClass: 'el-icon-files', module: 'businessChances', keepAlive: false, roles: ["BUSINESS_CHANCE_USER", "BUSINESS_CHANCE_ADMIN", "BUSINESS_CHANCE_OBSERVER"] }
    }
  ]
}

export default merchantRouter